module.exports = __webpack_public_path__ + "static/img/35-北京理工大学附属中学南校区1.5957ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/35-北京理工大学附属中学南校区1.png
// module id = Z6BR
// module chunks = 0